<template>
  <div id="header">
    <div class="login-notice">

      <!--
      <template>
        <div>
          <div v-if="authState !== 'signedin'">You are signed out.</div>
          <amplify-authenticator>
            <div v-if="authState === 'signedin' && user">
              <div>Hello, {{user.username}}</div>
            </div>
            <amplify-sign-out></amplify-sign-out>
          </amplify-authenticator>
          <amplify-authenticator>
            <amplify-sign-up
              header-text="My Custom Sign Up Text"
              slot="sign-up"
            ></amplify-sign-up>
          </amplify-authenticator>
        </div>
      </template>
      -->

      <template v-if="createButton">
        <div class="guide-module item">
          <div class="guide-module-item">
            <h3 class="module-title">ログインをしてご利用ください</h3>
            <span>ご利用ありがとうございます。<br><br>
            新規相談をするにはログインをしてください。アカウントをお持ちでない場合は新規作成をしてください。</span>
          </div>
          <div style="margin:0 0 10px 15px">
            <a :href="adviserLink" target="_blank">
              <img :src="adviserImage" width="64px" style="border-radius:50%">
            </a> <b>{{adviserName}}</b>
          </div>
        </div>
      </template>
      <template v-if="$route.query.type == 'signup'">
        <div class="guide-module-item">アカウントを作成して相談してみましょう！ 全部で3ステップで完了です。</div>
        <div class="step">STEP 1</div>
        <div class="step-body">
          <span class="step-title"><a href="/terms">利用規約</a>・<a href="/privacy">プライバシーポリシー</a>を確認し、下の「同意してアカウント作成」ボタンを押す</span>
        </div>
        <div class="step">STEP 2</div>
        <div class="step-body">
          <span class="step-title">アカウント<small>（メールアドレス）</small>とパスワードを設定して、「アカウント作成」ボタンを押す</span>
        </div>
        <div class="step">STEP 3</div>
        <div class="step-body">
          <span class="step-title">登録メールに記載されている「認証コード」を入力する</span>
          <span class="step-note">この確認により、あなたの相談内容が誤って他人のメールアドレスで確認されることを防ぎます</span>
        </div>
        <div class="step"></div>
        <div class="step-body">
          <span class="step-title">以上でアカウント作成は完了です！</span>
          <span class="step-note">登録したアカウント（メールアドレス）とパスワードでログインしてみましょう</span>
        </div>

        <template v-if="appClass === 'hama'">
          <br>
          <div class="item terms" style="border-style:solid; padding: 5px;">
            「浜松オンラインがん相談 for 浜松医大」は、CancerWithと浜松医科大学が連携し、浜松市に在住の方に限らず、浜松市と関係のある方・ゆかりのある方々に向けて提供するサービスです。そのため、以下のいずれかの条件に該当する方が無料で利用することができます。<br><br>
            <ol>
              <li>浜松市内の病院・クリニックへご通院されている方、もしくはそのご家族・ご友人の方</li>
              <li>浜松市内に在住、または通勤・通学をされている方</li>
              <li>その他、浜松市に関係のある方（例：浜松市に転居予定の方、浜松市出身の方 等）</li>
            </ol>
          </div>
        </template>
      </template>
      <template v-else>
        <ul>
          <li><a href="/terms">利用規約</a>・<a href="/privacy">プライバシーポリシー</a>に同意する場合のみ<template v-if="$route.query.type == 'signup'">アカウント作成およびサービス利用</template><template v-else>サービス利用</template>をしてください。</li>
          <template v-if="appClass === 'hama'">
            <br>
            <div class="item terms" style="border-style:solid; padding: 5px;">
              「浜松オンラインがん相談 for 浜松医大」は、CancerWithと浜松医科大学が連携し、浜松市に在住の方に限らず、浜松市と関係のある方・ゆかりのある方々に向けて提供するサービスです。そのため、以下のいずれかの条件に該当する方が無料で利用することができます。<br><br>
              <ol>
                <li>浜松市内の病院・クリニックへご通院されている方、もしくはそのご家族・ご友人の方</li>
                <li>浜松市内に在住、または通勤・通学をされている方</li>
                <li>その他、浜松市に関係のある方（例：浜松市に転居予定の方、浜松市出身の方 等）</li>
              </ol>
            </div>
          </template>
        </ul>
        <br>
      </template>
      <br>
      <button @click="showLogin = true" v-if="!showLogin" class="footerNavi-button button-primary">
        同意して<template v-if="$route.query.type == 'signup'">アカウント作成</template><template v-else>ログイン</template>する
      </button>
    </div>
    <transition name="fadeLogin">
      <div v-if="showLogin" class="login-notice">
        アカウント発行や基本的な操作手順のマニュアルは <a href="/help">こちら</a>
        <template v-if="$route.query.type == 'signup'">
          <div>
            <amplify-authenticator v-bind:authConfig="authConfig" v-bind:style="styles" class="authenticator__form" :initial-auth-state="initState" hide-toast>
              <amplify-sign-up v-bind:signUpConfig="authConfig.signUpConfig" v-bind:style="styles" id="amplify-sign-up" class="authenticator__form" slot="sign-up" username-alias="username" :formFields.prop="formFields"></amplify-sign-up>
              <amplify-check-box errorMessage="validationErrors.acknowledgement" />
            </amplify-authenticator>
            <a href="?type=signin"><button class="footerNavi-button button-secondary width">
              アカウント作成済みの方【ログイン】
            </button></a>
          </div>
        </template>
        <template v-else>
          <amplify-authenticator v-bind:authConfig="authConfig" v-bind:style="styles" class="authenticator__form" id="amplify-sign-in" hide-toast></amplify-authenticator>
          <a href="?type=signup"><button class="footerNavi-button button-secondary width">
            初めてご利用の方【アカウント新規作成】
          </button></a>
        </template>
        <div class="width">
        ※キャリアメール（@docomo.ne.jp、@softbank.ne.jp、@ezweb.ne.jp等）をお使いの場合、迷惑メールフィルタの影響で認証コードが届かない場合があります。<br>
        その場合は、恐れ入りますが <a :href="contactUrl">こちら</a> からお問い合わせお願いします。
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Analytics/*, Logger*/ } from "aws-amplify"
import { Common } from './Common.js'
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import { Hub } from '@aws-amplify/core'

export default {
  props:['createButton'],
  mixins:[Common],
  data() {
    return {
      formFields: [
        {
          type: 'username',
          required: true,
          handleInputChange: (event, cb) => {
            var inputChar = event.data
            var msg = ''

            // 全角文字チェック
            if (! String(inputChar).match(/[\x01-\x7E\uFF65-\uFF9F]/)) {   
              msg = '全角文字は使えません。メールアドレスを確認してください。'
            } else {
              // スペース・タブ・改行チェック
              if (String(inputChar) !== String(inputChar).replace(/\s+/g, '')) {
                msg = 'スペースは使えません。メールアドレスを確認してください。'
              } else {
                msg = ''
              }              
            }
            const shadowRoot = document.getElementById('amplify-sign-up').shadowRoot;
            const input = shadowRoot.getElementById('username')
            const submit = shadowRoot.querySelectorAll("button[type='submit']")[0]
            console.log(inputChar)
            input.setCustomValidity(msg);
            if (msg) {
              if (msg.length > 0) {
                submit.click();
              }      
            }  
            cb(event);
          },
        },
        {
          type: 'password',
          required: true,
          handleInputChange: (event, cb) => {
            //console.log('custom pwd field');
            cb(event);
          },
        },
      ],
      signedIn: false,
      usernameAttributes: 'Email',
      authConfig: {
        signUpConfig: {
          hiddenDefaults: ['phone_number', 'email']
        }
      },
      showLogin: false,
      appClass: '',
      styles: {
        //'min-width': 'auto !important',
      },
      initState: AuthState.SignUp,
      nextAuthState: null,
      adviserName: '',
      adviserLink: '',
      adviserImage: '',
//      user: undefined,
//      authState: undefined,
//      unsubscribeAuth: undefined,
    }
  },

  /*
  created() {
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState = authState;
      this.user = authData;
    });
  },
  */


  mounted() {
    let env = this.getEnv(location.hostname)
    this.appClass = this.getAppDivClass(location.hostname)
    if (this.appClass === 'hama') {
      this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_env=' + env // 浜松オンラインがん相談版
    } else {
      this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_env=' + env // CancerWith版
    }
    this.appClass = this.getAppDivClass(location.hostname)

    var guideAdviser = this.getGuideAdviser(location.hostname)
    this.adviserName = guideAdviser.adviserName
    this.adviserLink = guideAdviser.adviserLink
    this.adviserImage = guideAdviser.adviserImage
  },

  /*
  beforeDestroy() {
    this.unsubscribeAuth();
  },
  */

  async beforeCreate() {
    onAuthUIStateChange((nextAuthState, authData) => {
      this.nextAuthState = nextAuthState
      if (nextAuthState === AuthState.SignedIn) {
        //console.log('user successfully signed in!');
        //console.log('user data: ', authData);
      }
      if (!authData) {
        //console.log('user is not signed in...');
      }
    });

    // Toastのエラー表示を独自に表示
    Hub.listen( 'UI Auth', async ( data ) => {
      /*
      let shadowRoot = null
      if (this.$route.query.type == 'signup') {
        shadowRoot = document.getElementById('amplify-sign-up').shadowRoot;
      } else {
        shadowRoot = document.getElementById('amplify-sign-in').shadowRoot;
      }
      
      const input = shadowRoot.getElementById('username')
      const submit = shadowRoot.querySelectorAll("button[type='submit']")[0]
      var msg = data.payload.message
      console.log(msg)
      input.setCustomValidity(msg);
      if (msg.length > 0) {
        submit.click();
      }
      */
      if (data.payload.event === 'ToastAuthError') {
        //console.log(data)
        //console.log(data.payload)
        if (data.payload.message) {
          if (!data.payload.message.startsWith('Cannot read properties of') && !data.payload.message.startsWith('Network error')) {
            alert(data.payload.message)
          }
        }
      }
      //console.log(data.payload)
    } );


    Analytics.record({
      name: 'accessLog',
      attributes: {
        page: 'Login',
        url: window.location.origin + window.location.pathname
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      this.$gtag.pageview({
        page_path: '/login',
        page_title: 'ログイン・アカウント作成 (/login)'
      })
    }
  }
}
</script>
<style>
.authenticator__form {
  --container-display: auto;
}

.login-notice {
  padding: 10px; 
}

.Form__formSection___3tqxz {
  max-width: 480px !important;
  min-width: auto !important;
}

.Section__sectionFooter___1QlDn {
  display: block;
}

.Button__button___1FrBC {
  width: 100%;
}

a[data-test="sign-in-create-account-link"] {
  display: none !important;
}

a[data-test="sign-up-sign-in-link"] {
  display: none !important;
}

.width {
  max-width: 480px;
  margin: 15px;
}

.sign-in-form-footer {
  display: none !important;
}

</style>